<template xmlns="http://www.w3.org/1999/html">
  <div class="form-group">
    <table class="table">
      <tbody>
      <tr>
        <td>フリーワード</td>
        <td><input type="text" class="form-control input-sm" v-model="params.keyword"></td>
      </tr>

      </tbody>
    </table>
    <div class="form-group">
      <div class="col-xs-12">
        <button class="btn btn-block btn-primary" @click="search">検索</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      params: {
        default: function () {
          return {keyword: ''}
        }
      }
    },
    watch: {
      params: {
        deep: true,
        handler: function () {
          this.$emit('update.params', this.params)
        }
      }
    },
    created: function () {
      this.$emit('clickSearch')
    },
    methods: {
      search: function () {
        this.$emit('clickSearch')
      }
    }
  }
</script>




// WEBPACK FOOTER //
// Search.vue?3344da8d